import { Stack } from "@mui/material";
import { CbhIcon, type IconType, Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

interface TermsListItemProps {
  iconType: IconType;
  title: string;
  children: ReactNode;
}

export function TermsListItem(props: TermsListItemProps) {
  const { iconType, title, children } = props;
  return (
    <Stack direction="row" spacing={5} alignItems="flex-start">
      <CbhIcon type={iconType} />
      <Stack spacing={2}>
        <Text bold variant="body1" sx={{ color: (theme) => theme.palette.text.primary }}>
          {title}
        </Text>
        {typeof children === "string" ? (
          <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {children}
          </Text>
        ) : (
          children
        )}
      </Stack>
    </Stack>
  );
}
